import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { BookingInfoProperties, BookingPassengerInfoProperties } from '../Models/BookingPassengerTicketIssuanceProperties';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
@Component({
  selector: 'app-emirates-modification',
  templateUrl: './emirates-modification.component.html',
  styleUrls: ['./emirates-modification.component.css'],
})
export class EmiratesModificationComponent  {
  removePassengerPopup: boolean;
  optionchangeforsomepass: boolean = true;
  constructor(private messageservice: MessageService, private ticketIssuanceService: TicketIssuanceService, private confirmationService: ConfirmationService, private router: Router) { }
  optionlist: any[] | undefined;
  selectoption: string | undefined;
  changeBooking: boolean = false;
  refundBooking: boolean = false;
  removepassengers: boolean = false;
  bookingInfo = new BookingInfoProperties();
  ngOnInit() {
    let actionperformed = localStorage.getItem("actiontype");
    this.bookingInfo = JSON.parse(localStorage.getItem("bookingInfoEmirates"));
    if (actionperformed == "changeBooking") {
      this.changeBooking = true;
      if (this.bookingInfo.bookingPassengerInfoProperties.length == 1) {
        this.selectoption = "all";
        this.onOptionChange();
        this.optionchangeforsomepass = false;
      }

      if (this.bookingInfo.bookingPassengerInfoProperties.length == 2) {
        if (this.bookingInfo.bookingPassengerInfoProperties.find(f => f.passengerType == 3 && f.isDeleted ==false)) {
          this.selectoption = "all";
          this.onOptionChange();
          this.optionchangeforsomepass = false;
        }
      }
      
  
    }
    else if (actionperformed == "refundBooking") {
      this.refundBooking = true;
    }
    else if (actionperformed == "removepassengers") {
      this.removepassengers = true;
    }
    this.optionlist = [
      { name: 'All Passenger', code: 'all' },
      { name: 'Some Passenger', code: 'some' }
    ];
  }
  activeColor: string = '';

  changeBackground(color: string) {
    this.activeColor = color;
  }
  somepassengers: boolean = false;
  aLLpassengers: boolean = false;

  passengers: string[] = ['Passenger 1', 'Passenger 2', 'Passenger 3', 'Passenger 4'];
  selectedPassengers: { [key: string]: boolean } = {};
  buttonsshow: boolean = false;
  onOptionChange() {
    if (this.selectoption == "some") {
      for (let p = 0; p < this.bookingInfo.bookingPassengerInfoProperties.length; p++) {
        this.bookingInfo.bookingPassengerInfoProperties[p].selectedForModify = false;
      }
      this.somepassengers = true;
      this.buttonsshow = true;
      this.aLLpassengers = false;
    }
    else {
      for (let p = 0; p < this.bookingInfo.bookingPassengerInfoProperties.length; p++) {
        this.bookingInfo.bookingPassengerInfoProperties[p].selectedForModify = true;
      }
      this.buttonsshow = true;
      this.somepassengers = true;
      this.aLLpassengers = true;
    }
  }
  RemovePreTicketIssuance() {

    this.ticketIssuanceService.RemovePassengerEmirates(this.bookingInfo).subscribe((data) => {
      if (data.isSaved == true) {

      
        this.NewLoaderEmirates = false;
        this.messageservice.add({ severity: 'success', summary: 'Confirmed', detail: 'Removed Successfully', life: 3000 });
        this.router.navigateByUrl('/ticket-issuance');

      }
      else {
        this.NewLoaderEmirates = false;
        this.messageservice.add({ severity: 'error', summary: 'Error', detail: data.errorInfo });

      }
    });
  }
  NewLoaderEmirates: boolean = false;
  confirmRemovePreTicketIssuance() {
    document.getElementById("selectatleastoneremove").innerHTML = "";
    let count = 0;
    for (let p = 0; p < this.bookingInfo.bookingPassengerInfoProperties.length; p++) {
      if (this.bookingInfo.bookingPassengerInfoProperties[p].isDeleted) {
        count++;
      }
    }
    if (count == 0) {
      document.getElementById("selectatleastoneremove").innerHTML = "Please Select at least one!";
      return;
    }
    if (count == this.bookingInfo.bookingPassengerInfoProperties.length) {
      document.getElementById("selectatleastoneremove").innerHTML = "Not Remove All, Only some Passengers";
      return;
    }
    let adultexist =false;
    if (count != this.bookingInfo.bookingPassengerInfoProperties.length) {
   
      for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
        if (this.bookingInfo.bookingPassengerInfoProperties[k].passengerType == 1) {
          if (!this.bookingInfo.bookingPassengerInfoProperties[k].isDeleted) {
            adultexist=true;
          }
        }

      }
    }
    if (!adultexist) {
      document.getElementById("selectatleastoneremove").innerHTML = "Must be one adult in booking, not remove all the adult";
      return;
    }
  
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: 'Please confirm to proceed moving forward.',
      acceptIcon: 'pi pi-check mr-2',
      rejectIcon: 'pi pi-times mr-2',
      rejectButtonStyleClass: 'p-button-sm',
      acceptButtonStyleClass: 'p-button-outlined p-button-sm',
      accept: () => {
        this.NewLoaderEmirates = true;
        this.RemovePreTicketIssuance();
      },
      reject: () => {
        this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Not Removed', life: 3000 });
        this.NewLoaderEmirates = false;
      }
    });
  }
  Removecheckpassenger(passenger: BookingPassengerInfoProperties) {
    if (this.bookingInfo.providerCode == "EK") {
      if (passenger.isDeleted) {
        if (passenger.passengerType == 1) {
          for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
            if (passenger.firstName == this.bookingInfo.bookingPassengerInfoProperties[k].associatedAdult) {
              if (!this.bookingInfo.bookingPassengerInfoProperties[k].isDeleted) {
                this.bookingInfo.bookingPassengerInfoProperties[k].isDeleted = true;
                break;
              }
            }
          }
        }
        if (passenger.passengerType == 3) {
          for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
            if (passenger.associatedAdult == this.bookingInfo.bookingPassengerInfoProperties[k].firstName) {
              if (!this.bookingInfo.bookingPassengerInfoProperties[k].isDeleted) {
                this.bookingInfo.bookingPassengerInfoProperties[k].isDeleted = true;
                break;
              }
            }
          }
        }
      }
      else {
        if (!passenger.isDeleted) {
          if (passenger.passengerType == 1) {
            for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
              if (passenger.firstName == this.bookingInfo.bookingPassengerInfoProperties[k].associatedAdult) {
                if (this.bookingInfo.bookingPassengerInfoProperties[k].isDeleted) {
                  this.bookingInfo.bookingPassengerInfoProperties[k].isDeleted = false;
                  break;
                }
              }
            }
          }
          if (passenger.passengerType == 3) {
            for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
              if (passenger.associatedAdult == this.bookingInfo.bookingPassengerInfoProperties[k].firstName) {
                if (this.bookingInfo.bookingPassengerInfoProperties[k].isDeleted) {
                  this.bookingInfo.bookingPassengerInfoProperties[k].isDeleted = false;
                  break;
                }
              }
            }
          }
        }
      }


    }
  }
  Modifycheckpassenger(passenger: BookingPassengerInfoProperties) {
    if (this.bookingInfo.providerCode == "EK") {
      if (passenger.selectedForModify) {
        if (passenger.passengerType == 1) {
          for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
            if (passenger.firstName == this.bookingInfo.bookingPassengerInfoProperties[k].associatedAdult) {
              if (!this.bookingInfo.bookingPassengerInfoProperties[k].selectedForModify) {
                this.bookingInfo.bookingPassengerInfoProperties[k].selectedForModify = true;
                break;
              }
            }
          }
        }
        if (passenger.passengerType == 3) {
          for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
            if (passenger.associatedAdult == this.bookingInfo.bookingPassengerInfoProperties[k].firstName) {
              if (!this.bookingInfo.bookingPassengerInfoProperties[k].selectedForModify) {
                this.bookingInfo.bookingPassengerInfoProperties[k].selectedForModify = true;
                break;
              }
            }
          }
        }
      }
      else {
        if (!passenger.selectedForModify) {
          if (passenger.passengerType == 1) {
            for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
              if (passenger.firstName == this.bookingInfo.bookingPassengerInfoProperties[k].associatedAdult) {
                if (this.bookingInfo.bookingPassengerInfoProperties[k].selectedForModify) {
                  this.bookingInfo.bookingPassengerInfoProperties[k].selectedForModify = false;
                  break;
                }
              }
            }
          }
          if (passenger.passengerType == 3) {
            for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
              if (passenger.associatedAdult == this.bookingInfo.bookingPassengerInfoProperties[k].firstName) {
                if (this.bookingInfo.bookingPassengerInfoProperties[k].selectedForModify) {
                  this.bookingInfo.bookingPassengerInfoProperties[k].selectedForModify = false;
                  break;
                }
              }
            }
          }
        }
      }


    }
  }
  modifyClick() {
    if (this.selectoption == "some") {
      let countofsome = 0;
      for (let p = 0; p < this.bookingInfo.bookingPassengerInfoProperties.length; p++) {
        if (this.bookingInfo.bookingPassengerInfoProperties[p].selectedForModify) {
          countofsome++;
        }
      }
      if (countofsome == this.bookingInfo.bookingPassengerInfoProperties.length) {
        this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Select Some Passenger Only', life: 3000 });
        return;
      }
    }
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: 'Please confirm to proceed moving forward.',
      acceptIcon: 'pi pi-check mr-2',
      rejectIcon: 'pi pi-times mr-2',
      rejectButtonStyleClass: 'p-button-sm',
      acceptButtonStyleClass: 'p-button-outlined p-button-sm',
      accept: () => {
        localStorage.setItem("flightmodifyBookingInfo", JSON.stringify(this.bookingInfo));
        localStorage.setItem("flightmodifysearch", JSON.stringify(this.bookingInfo.galileoBookingProp.flightProp));
        this.router.navigateByUrl('/flightResultModify');
      },
      reject: () => {
        this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Not Modify', life: 3000 });
      }
    });

    
  }

}
